import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/wingman/7b8b7474-e52e-4388-adc0-a2361520c0a4/attachments/8840390a845949e6b9092405676c1743_image.png";

const LegalLayout = ({ eyebrow, title, updated, children, testid }) => (
  <div className="min-h-screen bg-[#060A14] text-white flex flex-col" data-testid={testid}>
    <header className="px-4 sm:px-6 py-5 border-b border-white/10 flex items-center justify-between max-w-6xl mx-auto w-full">
      <Link
        to="/"
        data-testid="legal-back-link"
        className="inline-flex items-center gap-2 text-[10px] tracking-[0.28em] uppercase text-[#94A3B8] hover:text-white"
      >
        <ArrowLeft className="w-3.5 h-3.5" />
        Torna al sito
      </Link>
      <img src={LOGO_URL} alt="LEOVERA" className="h-10 w-auto bg-white rounded-md p-1" />
    </header>

    <main className="flex-1 max-w-3xl w-full mx-auto px-4 sm:px-6 py-14 sm:py-20">
      <span className="text-[10px] tracking-[0.36em] uppercase text-[#C0C0C0]">{eyebrow}</span>
      <h1 className="mt-3 font-[Outfit] text-white text-3xl sm:text-4xl tracking-tight font-light">
        {title}
      </h1>
      {updated && (
        <p className="mt-3 text-[11px] tracking-[0.24em] uppercase text-[#94A3B8]">
          Ultimo aggiornamento · {updated}
        </p>
      )}

      <div className="mt-10 space-y-8 text-[14px] leading-relaxed text-[#CBD5E1] font-[Manrope] legal-prose">
        {children}
      </div>

      <div className="mt-14 pt-6 border-t border-white/10 flex items-center gap-2 text-[10px] tracking-[0.24em] uppercase text-[#94A3B8]">
        <ShieldCheck className="w-3.5 h-3.5 text-emerald-300" />
        Documento redatto in conformità al Reg. (UE) 2016/679 (GDPR) e al D.lgs. 196/2003
      </div>
    </main>

    <style>{`
      .legal-prose h2 { font-family: "Outfit", sans-serif; color:#fff; font-size:1.15rem; letter-spacing:-0.01em; font-weight:400; margin-top:1.5rem; }
      .legal-prose h3 { font-family: "Outfit", sans-serif; color:#E5E4E2; font-size:0.95rem; margin-top:1.25rem; }
      .legal-prose ul { list-style: disc; padding-left: 1.25rem; }
      .legal-prose li { margin-bottom: 0.35rem; }
      .legal-prose strong { color:#E5E4E2; font-weight:500; }
      .legal-prose a { color:#C0C0C0; text-decoration: underline; text-underline-offset: 2px; }
      .legal-prose a:hover { color:#fff; }
    `}</style>
  </div>
);

export default LegalLayout;
